(() => {
  'use strict';

  const prefetched = new Set();
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const saveData = connection && connection.saveData;
  const slowConnection = connection && /(^|-)2g$|slow-2g/.test(connection.effectiveType || '');

  const isEligible = (link) => {
    if (!link || !link.href || link.target === '_blank' || link.hasAttribute('download')) return false;
    if (link.origin !== window.location.origin) return false;
    if (link.pathname === window.location.pathname && !link.hash) return false;
    if (/\/(cart|checkout|account|login|logout)(\/|$)/i.test(link.pathname)) return false;
    if (/^(mailto:|tel:|javascript:)/i.test(link.href)) return false;
    if (/wa\.me|instagram\.com|tiktok\.com/i.test(link.href)) return false;
    return /\/(products|collections|pages)(\/|$)/i.test(link.pathname) || link.pathname === '/';
  };

  const prefetch = (link) => {
    if (saveData || slowConnection || !isEligible(link) || prefetched.has(link.href)) return;
    prefetched.add(link.href);
    const hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.as = 'document';
    hint.href = link.href;
    hint.fetchPriority = 'low';
    document.head.appendChild(hint);
  };

  document.addEventListener('pointerover', (event) => {
    const link = event.target.closest?.('a');
    if (link) prefetch(link);
  }, { passive: true });

  document.addEventListener('touchstart', (event) => {
    const link = event.target.closest?.('a');
    if (link) prefetch(link);
  }, { passive: true });

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a');
    if (!link || event.defaultPrevented || !isEligible(link)) return;
    document.documentElement.classList.add('amara-navigating');
  }, { passive: true });
})();
